import { PayloadAction } from "@reduxjs/toolkit";
import { GuaranteesReferential } from "features/subscription-process/pricing-process/types/interfaces";
import { PricingState } from "../pricingSlice";

export const guaranteesFiltersReducers = {
  updateGlobalGuarantees: (state: PricingState, action: PayloadAction<GuaranteesReferential>) => {
    state.globalGuarantees = action.payload
  },
  setGuaranteeLastResearchHash: (state: PricingState, action: PayloadAction<string>) => {
    state.guaranteeLastResearchHash = action.payload
  },
  clearGuaranteeLastResearchHash: (state: PricingState) => {
    state.guaranteeLastResearchHash = null
  },
}

